import { Endpoints } from "~constants/endpoints"
import { Api } from "~utils/api"

const EligibilityService = {
  getEligibilityByUser: async (userId: string, { pageParam }) => {
    const url = `${Endpoints.PERKS_ELIGIBILITY.URL}?sort=weight,asc&userId=${userId}&page=${pageParam}`
    try {
      const response = await Api.get(url)
      return {
        result: response.data.data,
        hasNextPage: response.data.hasNext ? pageParam + 1 : false,
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

export default EligibilityService
